import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import StorageService from "@infrastructure/Services/StorageService";

const prefix = StorageService.STORAGE_PREFIX;

interface HiddenPromoPostsStore {
    hiddenPosts: { [key: number]: boolean };
    hidePost: (value: number) => void;
    isPostHidden: (value: number) => boolean;
}

export const useHiddenPromoPostsStore = create<HiddenPromoPostsStore>()(
    persist(
        (set, get) => ({
            hiddenPosts: {},
            isPostHidden: (value) => get().hiddenPosts[value] ?? false,
            hidePost: (value) =>
                set({
                    hiddenPosts: {
                        ...get().hiddenPosts,
                        [value]: true,
                    },
                }),
        }),
        {
            name: `${prefix}promoPosts-hidden`,
            storage: createJSONStorage(() => localStorage),
        },
    ),
);
